import { streamingProgressAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import { ProgressBar as ProgressBarComponent } from "@zapier/design-system";

export const ProgressBar = () => {
  const progress = useAtomValue(streamingProgressAtom);

  return <ProgressBarComponent color="Purple4" value={progress / 100} />;
};
